import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../components/Base';
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "RadioButtonGroup-root_2yzsq",
  "label": "RadioButtonGroup-label_1d7TS",
  "input": "RadioButtonGroup-input_33aZQ",
  "content": "RadioButtonGroup-content_2dqic",
  "footer": "RadioButtonGroup-footer_5crdY",
  "inline": "RadioButtonGroup-inline_2C_Cu",
  "full": "RadioButtonGroup-full_2a6e8",
  "disabled": "RadioButtonGroup-disabled_14X09"
};
function RadioButtonGroup({
  type = 'radio',
  ...extraProps
}) {
  const [state, setState] = React.useState({
    options: []
  });
  const onChange = evt => {
    const inputValue = evt.target.value;
    const options = [...state.options];
    if (evt.target.checked) {
      options.push(inputValue);
    } else {
      const index = options.indexOf(inputValue);
      options.splice(index, 1);
    }
    setState({
      options
    });
    if (type === 'checkbox' && extraProps.onChange) {
      extraProps.onChange(options);
    }
  };
  const onLabelClick = (value, idx) => evt => {
    if (extraProps.onLabelClick) {
      extraProps.onLabelClick(evt, value, idx);
    }
  };
  const getExtraProps = () => {
    const {
      items,
      name,
      className,
      onLabelClick,
      value,
      required,
      label,
      checked,
      full,
      ...extra
    } = extraProps;
    return extra;
  };
  const content = [];
  extraProps.items.forEach((item, idx) => {
    const isCheckbox = type === 'checkbox';
    const identifier = `${extraProps.name}-${item.value}`;
    if (isCheckbox) {
      content.push(/*#__PURE__*/_createElement("input", {
        type: "checkbox",
        className: styles.input,
        name: item.name || extraProps.name,
        ...getExtraProps(),
        key: `input-${identifier}`,
        id: identifier,
        value: item.value,
        checked: state.options.indexOf(item.value) !== -1,
        onChange: onChange
      }));
    } else {
      content.push(/*#__PURE__*/_createElement("input", {
        type: "radio",
        className: styles.input,
        name: extraProps.name,
        ...getExtraProps(),
        key: `input-${identifier}`,
        id: identifier,
        value: item.value,
        checked: item.value === extraProps.value
      }));
    }
    content.push(/*#__PURE__*/_jsxs("label", {
      htmlFor: identifier,
      className: clsx(styles.label, {
        [styles.disabled]: item.disabled
      }),
      onClick: onLabelClick(item.value, idx),
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: item.label
      }), item.footer ? /*#__PURE__*/_jsx("div", {
        className: styles.footer,
        children: item.footer
      }) : null]
    }, `label-${identifier}`));
  });
  return /*#__PURE__*/_jsx(Base, {
    position: "relative",
    className: clsx(styles.root, {
      [styles.inline]: !extraProps.full,
      [styles.full]: extraProps.full
    }, extraProps.className),
    children: content
  });
}
export default RadioButtonGroup;